import deepClone from "foundation/js/deepClone"
import GetLabel from "foundation/js/getLabel"
import { computed, ref, onMounted } from "vue"
import { useStore } from "vuex"
import GroupPost from "../GroupPost/GroupPost"
import FeaturedPostSpotCard from "../FeaturedPostSpotCard/FeaturedPostSpotCard"

export default {
    name: "FrivilligePostsList",
    components: {
        GroupPost,
        FeaturedPostSpotCard
    },
    props: {
        guid: {
            type: String,
            required: true
        },
        groupId: {
            type: String,
            required: true
        },
        featuredPostSpotCards: {
            type: Object,
            required: false,
            default: null
        },
        isMember: {
            type: Boolean,
            required: true,
            default: false
        },
        isLoggedIn: {
            type: Boolean,
            required: true,
            default: false
        },
        skip: {
            type: Number,
            required: true,
            default: 0
        },
        take: {
            type: Number,
            required: false,
            default: 8
        },
        universId: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const numberOfItems = ref(0)
        
        const numFeaturedPosts =  props.featuredPostSpotCards?.length ?? 0
        const posts = computed(() => deepClone(store.state.search.results[props.guid] ?? []))
        const totalAmount = computed(() => numFeaturedPosts + store.state.search.scoped_total[props.guid] ?? 0)
        const showSpinner = computed(()=> store.state.search.search_inprogress[props.guid] )

        onMounted(() => {
            store.commit('search/set_replaceQueryInUrl', false)

            store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: props.take,
                showMorePageSize: props.take,
                url: process.env.COMMUNITY_GET_POSTS + "?groupId=" + props.groupId + "&comments=1"
            })

            store.dispatch('search/performSearch', {
                guid: props.guid,
                query: '',
                skip: props.skip,
                take: props.take,
            })
        })

        const getMorePosts = () => {
            store.dispatch('search/performMoreSearch', { guid: props.guid })
        }

        const handlePostClick = (e, post) => {
            if (props.isMember) //An user can be assumed to be a member if they are an admin by default. So this redirects them accordingly.
            {
                window.location.href = post.url
            }
            else
            {
                if(!props.isLoggedIn){
                    store.dispatch('main/openPageOverlay', {
                        overlayContent: "LoginOverlay",
                        returnTarget: e.currentTarget
                    })
                    
                    return
                }

                if (!props.isMember) {
                    store.commit('main/set_page_overlay_content_data', { isFrivilligContext: true })

                    store.dispatch('main/openPageOverlay', {
                        overlayContent: "ClosedGroupOverlay",
                        returnTarget: e.currentTarget
                    })

                    return
                }
                window.location.href = post.url
            }


        }

        return {
            numberOfItems,
            showSpinner,
            posts,
            totalAmount,
            handlePostClick,
            getMorePosts,
            getLabel: (labelKey, params) => GetLabel({ labelKey, labelCollection: 'FrivilligePostsList', params })
        }
    },
}